var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSons = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    style: {
      enableBackground: "new 0 0 102 102"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:transparent;}\n\t.st1{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 51,
    cy: 51,
    r: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.44,51.02c0,7.52,0,15.04,0,22.55c0,0.88-0.23,1.63-0.95,2.17c-0.9,0.68-2.12,0.59-3.03-0.2 c-4.93-4.27-9.86-8.54-14.77-12.82c-0.46-0.4-0.91-0.58-1.52-0.58c-4.25,0.02-3,0.01-7.25,0.01c-1.91,0-2.8-0.89-2.8-2.79 c0-5.72-0.01-11.44,0-17.16c0-1.24,0.57-2.1,1.6-2.43c0.31-0.1,0.65-0.12,0.97-0.12c4.41-0.01,3.33-0.01,7.74,0.01 c0.55,0,0.96-0.14,1.38-0.5c4.85-4.22,9.72-8.42,14.57-12.63c1.18-1.02,2.66-0.99,3.53,0.14c0.26,0.34,0.4,0.82,0.5,1.25 c0.08,0.37,0.04,0.77,0.04,1.15C50.44,36.39,50.44,43.71,50.44,51.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,50.24c-0.07,9.53-2.7,17.4-7.93,24.39c-0.51,0.68-1.03,1.31-1.92,1.42c-0.96,0.12-1.75-0.22-2.27-1.03 c-0.54-0.83-0.55-1.71-0.01-2.54c0.66-0.99,1.4-1.93,2.04-2.93c2.44-3.77,4.09-7.86,4.85-12.29c1.67-9.84-0.42-18.81-6.39-26.84 c-0.21-0.28-0.42-0.55-0.61-0.85c-0.67-1.09-0.42-2.38,0.58-3.13c0.96-0.71,2.35-0.6,3.11,0.38c0.99,1.27,1.93,2.58,2.78,3.95 c2.88,4.62,4.67,9.65,5.38,15.05C81.74,47.56,81.82,49.3,81.9,50.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.16,51.13c-0.04-5.41-1.56-10.36-4.68-14.8c-0.12-0.16-0.23-0.33-0.34-0.5c-0.76-1.16-0.53-2.57,0.54-3.31 c1.07-0.74,2.43-0.5,3.25,0.61c1.63,2.21,2.94,4.6,3.91,7.17c1.4,3.71,2.07,7.55,1.97,11.52c-0.16,6.3-2.12,12.01-5.79,17.12 c-0.78,1.09-2.21,1.34-3.26,0.6c-1.09-0.76-1.34-2.15-0.52-3.3c1.56-2.2,2.8-4.55,3.64-7.11C66.73,56.54,67.17,53.87,67.16,51.13z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.69,51.11c-0.03,3.94-1.04,7.61-3.09,10.97c-0.77,1.27-2.14,1.67-3.28,0.98c-1.16-0.7-1.48-2.09-0.72-3.36 c1.83-3.05,2.64-6.33,2.37-9.88c-0.2-2.64-0.99-5.1-2.41-7.34c-0.66-1.03-0.59-2.27,0.2-3.09c0.72-0.75,1.93-0.95,2.82-0.37 c0.38,0.25,0.72,0.63,0.97,1.02C60.64,43.43,61.66,47.13,61.69,51.11z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSons, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sons.3482b5a5.svg";
export { ForwardRef as ReactComponent };